
import React from "react";
import { CheckCircle, Link } from "lucide-react";

// WhatsApp Leads Data
const whatsappLeadsData = [
  {
    heading: "Reach Health & Wellness Shoppers with WhatsApp",
    points: [
      "Launch click-to-WhatsApp ads to gather customer details easily.",
      "Add a WhatsApp widget to your site for instant chats.",
      "Use QR codes on ads and packaging to get more opt-ins.",
      "Spread WhatsApp links across social media for wider reach.",
    ],
    // buttonText: "Get Start ",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/health_wellness/health_wellness_2.png",
  },
  {
    heading: "Turn Leads into Buyers with WhatsApp Automation",
    points: [
      "Send a warm welcome series to uncover customer needs.",
      "Share product highlights with photos and videos.",
      "Take payments directly in WhatsApp with checkout links.",
      "Remind customers to restock their wellness essentials.",
      "Switch COD orders to prepaid with smart workflows.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/health_wellness/health_wellness_3.png",
  },
  {
    heading: "Encourage Repeat Sales with Personalized Campaigns",
    points: [
      "Guide health-conscious shoppers with tailored assistance.",
      "Highlight testimonials and success stories for trust.",
    ],
    // buttonText: "Get Start ",
    buttonText: "Meta Policy for health wellness",
    buttonLink:"https://transparency.meta.com/en-gb/policies/ad-standards/restricted-goods-services/health-wellness/",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/health_wellness/health_wellness_4.png",
  },
  {
    heading: "Delight Customers at Every Step",
    points: [
      "Offer proactive support before, during, and after purchases.",
      "Send automated order updates and tracking alerts.",
      "Cut down returns with clear delivery notifications.",
      "Ask for reviews and feedback right on WhatsApp.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/health_wellness/health_wellness_5.png",
  },
  {
    heading: "Why WhatsApp Works for Health & Wellness",
    points: [
      "Messages are read in just 3 minutes on average.",
      "Enjoy a 98% open rate on broadcasts and updates.",
      "Get 45-57% click-through rates on your messages.",
      "Boost engagement by 53% across the buyer journey.",
    ],
    // buttonText: "Get Start ",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/health_wellness/health_wellness_6.png",
  },
];

const Healthcycle = () => {
  return (
    <>
      <div className="bg-gradient-to-r from-[#075E54] to-[#0a8a70] py-12 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-xl text-white">With the health and wellness market set to hit <span className="font-bold">$39.56 billion</span> by 2024 and growing at 5-10% yearly, see how WhatsApp helps top brands stand out and connect with customers.</p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-20">
        {whatsappLeadsData.map((item, index) => (
          <div key={index} className={`flex flex-col lg:flex-row items-center gap-16 my-20 ${index % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
            <div className="w-full lg:w-1/2">
              <img src={item.image} alt={item.heading} className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
            </div>
            <div className="w-full lg:w-1/2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">{item.heading}</h2>
              <ul className="space-y-4 text-gray-700">
                {item.points.map((point, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
              {item.buttonText && (
               
               <a
               href={item.buttonLink}
               className="mt-6 inline-block bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors"
             >
               {item.buttonText}
             </a>

              
                
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Healthcycle;